import highQualityLocationsWhitelist from '../constants/highQualityLocationsWhitelist'

export const COUNTRIES_WITH_ALLOWLISTED_BORDERS = new Set([
  'Canada',
  'United States'
])

export const COUNTRIES_WITH_ALLOWLISTED_BORDERS_PLUS_USA = new Set(
  COUNTRIES_WITH_ALLOWLISTED_BORDERS
).add('USA')

export const isHighQualityNonUSCountryCode = (
  countryCode: string | null
): boolean => {
  if (!countryCode) return false
  const countryCodesToNames = highQualityLocationsWhitelist.countryCodesToNames
  return countryCode !== 'US' && countryCodesToNames[countryCode] !== undefined
}
